import Image from "components/Elements/Image/Image";
import useMediaQueries from "hooks/useMediaQueries";
import { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";

interface ImageAnimatedWithContainerI {
  imagesNames: string[];
  animationDirection?: "left" | "right" | undefined;
  ext: "svg" | "gif" | "png" | "jpg" | undefined;
  className: string;
  containerClassName: string;
}

interface ImageItemI {
  name: string;
  ext: "svg" | "gif" | "png" | "jpg" | undefined;
  className: string;
  animationClassName: string;
  inView: boolean;
  index: number;
}

const ImageItem = ({
  name,
  ext,
  className,
  inView,
  animationClassName,
  index,
}: ImageItemI) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (inView) {
      setTimeout(() => {
        setMounted(true);
      }, 300 * index);
    }
  }, [inView]);

  return (
    <Image
      name={name}
      ext={ext}
      className={`hidden ${className} ${mounted ? animationClassName : ""} `}
      id={name.replace("/", "-")}
    />
  );
};

const ImageAnimatedWithContainer = ({
  imagesNames,
  className = "",
  animationDirection,
  ext = "svg",
  containerClassName,
}: ImageAnimatedWithContainerI) => {
  // creating a delay and preventing first inview trigger, cos on empty content its triggering imidiately
  const skipFirstRenderRef = useRef(true);

  const { mobileCondition } = useMediaQueries();

  useEffect(() => {
    setTimeout(() => {
      skipFirstRenderRef.current = false;
    }, 100);
  }, []);

  const [inViewRef, inView] = useInView({
    threshold: 0.3,
    rootMargin: "100px",
    triggerOnce: true,
    skip: skipFirstRenderRef.current,
  });

  const animationClassName =
    "animation-appear-" +
    (mobileCondition || !animationDirection ? "in" : animationDirection);

  return (
    <div className={containerClassName} ref={inViewRef}>
      {imagesNames.map((name, i) => (
        <ImageItem
          key={name}
          index={i}
          name={name}
          ext={ext}
          inView={inView}
          className={className}
          animationClassName={animationClassName}
        />
      ))}
    </div>
  );
};

export default ImageAnimatedWithContainer;
